import { Box, IconButton, Typography } from "@mui/material";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import CloseIcon from "@mui/icons-material/Close";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { buildSoundCloudUrl, getYouTubeId } from "../../utils/embed";
import { useYouTubeTitle } from "../../hooks/useYouTubeTitle";
import {
  dragItemSx,
  dragRowSx,
  dragHandleSx,
  dragIndexSx,
  dragTitleSx,
  dragUrlSx,
  dragDeleteBtnSx,
  iframeWrapSx,
  iframeOverlaySx,
} from "./style";

const SortableItem = ({ item, index, isDraggingAny, handleDeleteLink, embedType }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: item });

  const isYouTube = embedType === "youtube";
  const ytId = isYouTube ? getYouTubeId(item) : null;
  const { data: videoTitle } = useYouTubeTitle(ytId ? item : null);

  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      sx={[
        dragItemSx,
        {
          cursor: isDragging ? "grabbing" : "grab",
          transform: CSS.Transform.toString(transform),
          transition: transition ?? "border-color 0.2s",
          zIndex: isDragging ? 10 : "auto",
          opacity: isDragging ? 0.92 : 1,
          ...(isDragging && { boxShadow: "0 12px 40px rgba(0,0,0,0.7)" }),
        },
      ]}
    >
      <Box
        sx={[
          dragRowSx,
          {
            py: isYouTube ? 1.1 : 0.85,
            borderBottom: isYouTube ? "none" : "1px solid rgba(255,255,255,0.05)",
          },
        ]}
      >
        <DragIndicatorIcon sx={dragHandleSx} />
        <Typography sx={dragIndexSx}>{index + 1}</Typography>

        {isYouTube ? (
          <Typography
            sx={[
              dragTitleSx,
              {
                color: videoTitle ? "rgba(255,255,255,0.6)" : "rgba(255,255,255,0.25)",
                fontWeight: videoTitle ? 500 : 400,
                fontStyle: videoTitle ? "normal" : "italic",
              },
            ]}
          >
            {videoTitle ?? (ytId ? "Loading title…" : "Invalid YouTube URL")}
          </Typography>
        ) : (
          <Typography sx={dragUrlSx}>{item}</Typography>
        )}

        <IconButton size="small" onClick={() => handleDeleteLink(item)} sx={dragDeleteBtnSx}>
          <CloseIcon sx={{ fontSize: "13px" }} />
        </IconButton>
      </Box>

      {!isYouTube && (
        <Box sx={iframeWrapSx}>
          <iframe
            title={`SoundCloud ${index + 1}`}
            width="100%"
            height="166"
            allow="autoplay"
            src={buildSoundCloudUrl(item)}
          />
          {isDraggingAny && <Box sx={iframeOverlaySx} />}
        </Box>
      )}
    </Box>
  );
};

export default SortableItem;
